import { render, staticRenderFns } from "./FiltersSection.vue?vue&type=template&id=ba9be87c&"
import script from "./FiltersSection.vue?vue&type=script&lang=js&"
export * from "./FiltersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba9be87c')) {
      api.createRecord('ba9be87c', component.options)
    } else {
      api.reload('ba9be87c', component.options)
    }
    module.hot.accept("./FiltersSection.vue?vue&type=template&id=ba9be87c&", function () {
      api.rerender('ba9be87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/FiltersSection.vue"
export default component.exports